module.exports = __webpack_public_path__ + "img/vcmi_logo.19b6d09c.png";